import { useTranslation } from 'react-i18next';

/** Texto do chip da faixa de % (um chip só para a faixa inteira); `null` sem filtro. */
export function usePercentageRangeLabel() {
  const { t } = useTranslation('alocacao');
  return (min: number | undefined, max: number | undefined): string | null => {
    if (min !== undefined && max !== undefined) {
      return t('filtros.chips.percentualEntre', { min, max });
    }
    if (min !== undefined) return t('filtros.chips.percentualMinimo', { min });
    if (max !== undefined) return t('filtros.chips.percentualMaximo', { max });
    return null;
  };
}
